import { Language } from '../languages/labels/language.labels';

// Maps feature keys (from vocabulary.features / plan.features) to i18n label keys.
// The key names come from core FEATURE_DEFINITIONS — they are stable API contracts.
// Labels are commercial wording maintained in the 6 i18n files.
const FEATURE_LABEL_MAP: Record<string, keyof Language['labels']> = {
  'contacts':              'featureLabelContacts',
  'sale_core':             'featureLabelSaleCore',
  'purchase_core':         'featureLabelPurchaseCore',
  'treasury_payments':     'featureLabelTreasuryPayments',
  'catalog':               'featureLabelCatalog',
  'accounting_core':       'featureLabelAccountingCore',
  'archive_ocr':           'featureLabelArchiveOcr',
  'network_interbilling':  'featureLabelNetworkInterbilling',
  'payment_online':        'featureLabelPaymentOnline',
  'dunning':               'featureLabelDunning',
  'sale_recurring':        'featureLabelSaleRecurring',
  'treasury_ebanking':     'featureLabelTreasuryEbanking',
  'treasury_forecast':     'featureLabelTreasuryForecast',
  'projects_time':         'featureLabelProjectsTime',
  'pos':                   'featureLabelPos',
  'expenses':              'featureLabelExpenses',
  'inventory':             'featureLabelInventory',
  'sale_consignment':      'featureLabelSaleConsignment',
  'accounting_assets':     'featureLabelAccountingAssets',
  'service_repair':        'featureLabelServiceRepair',
  'rbac_advanced':         'featureLabelRbacAdvanced',
  'multi_company':         'featureLabelMultiCompany',
  'payroll':               'featureLabelPayroll',
  'storefront':            'featureLabelStorefront',
  'esignature':            'featureLabelEsignature',
  'mobile_sale':           'featureLabelMobileSale',
  'mobile_expenses':       'featureLabelMobileExpenses',
  'support_priority':      'featureLabelSupportPriority',
};

export function featureLabel(lang: Language, featureKey: string): string {
  const labelKey = FEATURE_LABEL_MAP[featureKey];
  if (labelKey) {
    const value = (lang.labels as any)[labelKey];
    if (value && typeof value === 'string') return value;
    // Label key exists in map but is empty/missing in this language — warn and show raw key
    console.warn(`[feature.labels] Missing translation for "${featureKey}" (label key: ${labelKey})`);
  } else {
    // Feature key not in map — new feature added in core but not yet translated
    console.warn(`[feature.labels] Unknown feature key "${featureKey}" — displaying raw key`);
  }
  // Fallback: display the raw key in a human-readable form — never blank
  return featureKey.replace(/[._]/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}
